import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Menu,
  MenuDivider,
  MenuItem,
  Popover,
} from '@blueprintjs/core';

import { useAppDispatch, useAppSelector } from '../../../../hooks';

import { LOGIN, PROFILE } from '../../routes';
import { AuthState } from '../../types';
import { doLogout } from '../../reducer';

const LoginHeaderButton = () => {
  const dispatch = useAppDispatch();
  const state: AuthState = useAppSelector((state) => state.auth);
  const navigate = useNavigate();

  const logout = useCallback(() => {
    dispatch(doLogout());
    window.location.reload();
  }, [dispatch]);

  const buildMenu = useCallback(() => {
    return (
      <Menu>
        <MenuItem
          icon="mugshot"
          onClick={() => navigate(PROFILE())}
          text="Perfil"
        />
        <MenuDivider />
        <MenuItem icon="log-out" onClick={() => logout()} text="Logoff" />
      </Menu>
    );
  }, [navigate, logout]);

  if (state.session.logged) {
    return (
      <Popover content={buildMenu()} placement="bottom">
        <Button
          className="bp5-minimal"
          icon="user"
          text={state.profile?.username}
        />
      </Popover>
    );
  } else {
    return (
      <>
        <Button
          className="bp5-minimal"
          icon="user"
          text="Login"
          onClick={() => navigate(LOGIN())}
        />
      </>
    );
  }
};

export default LoginHeaderButton;
